import { observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.

export const EmailValidationRules: EntityValidationRules<InputEmail> = {
  email: {
    isEmail: true,
  },
};

export const EmailConfirmationValidationRules: EntityValidationRules<InputEmail> = {
  emailConfirmation: {
    equalWith: { property: "email" as const },
    isEmail: true,
  },
};

export default class InputEmail {
  @observable
  email?: string;

  @observable
  emailConfirmation?: string;

  constructor(email: string | undefined, emailConfirmation: string | undefined) {
    this.email = email;
    this.emailConfirmation = emailConfirmation;
  }
}
